import * as binderAlertRates from "./enums/binderAlertRates";
import * as binderContentKeys from "./enums/binderContentKeys";
import * as binderOrderItemTypes from "./enums/binderOrderItemTypes";
import * as binderTabViewMenuNames from "./enums/binderTabViewMenuNames";
import * as binderTypes from "./enums/binderTypes";
import * as binderWallColumns from "./enums/binderWallColumns";
import * as filterNames from "./enums/filterNames";
import * as inputTypes from "./enums/inputTypes";
import * as libraryNames from "./enums/libraryNames";
import * as libraryServiceValues from "./enums/libraryServices";
import * as rendererNames from "./enums/rendererNames";
import * as searchResultsTypes from "./enums/searchResultsTypes";
import * as searchStartSectionNames from "./enums/searchStartSectionNames";
import * as tabContentKeys from "./enums/tabContentKeys";
import * as tabControlTypes from "./enums/tabControlTypes";
import * as tabDrawerTypes from "./enums/tabDrawerTypes";
import * as tableauFilterTypes from "./enums/tableauFilterTypes";
import * as targetDisplayValues from "./enums/targetDisplayValues";
import * as tileContentKeys from "./enums/tileContentKeys";
import * as tileNames from "./enums/tileNames";
import * as timelineChartTypes from "./enums/timelineChartTypes";
import * as userContentKeys from "./enums/userContentKeys";
import PropTypes from "prop-types";

/* eslint-disable import/namespace */
const binderAlertRatesArr = Object.keys(binderAlertRates).map((key) => binderAlertRates[key]);
const binderOrderItemTypesArr = Object.keys(binderOrderItemTypes).map(
	(key) => binderOrderItemTypes[key],
);
const searchResultsTypeArr = Object.keys(searchResultsTypes).map((key) => searchResultsTypes[key]);
const binderTypesArr = Object.keys(binderTypes).map((key) => binderTypes[key]);
const inputTypesArr = Object.keys(inputTypes).map((key) => inputTypes[key]);
const libraryNamesArr = Object.keys(libraryNames).map((key) => libraryNames[key]);
const rendererNamesArr = Object.keys(rendererNames).map((key) => rendererNames[key]);
const targetDisplayValsArr = Object.keys(targetDisplayValues).map(
	(key) => targetDisplayValues[key],
);
const tileNamesArr = Object.keys(tileNames).map((key) => tileNames[key]);
const binderTabViewMenuNamesArr = Object.keys(binderTabViewMenuNames).map(
	(key) => binderTabViewMenuNames[key],
);
const libraryServicesArr = Object.keys(libraryServiceValues).map(
	(key) => libraryServiceValues[key],
);
const tabDrawerTypesArr = Object.keys(tabDrawerTypes).map((key) => tabDrawerTypes[key]);
const binderListFiltersArr = Object.keys(filterNames).map((key) => filterNames[key]);
const tabControlTypesArr = Object.keys(tabControlTypes).map((key) => tabControlTypes[key]);
const tableauFilterTypesArr = Object.keys(tableauFilterTypes).map((key) => tableauFilterTypes[key]);
const binderWallColsArr = Object.keys(binderWallColumns).map((key) => binderWallColumns[key]);
const searchStartSectionNamesArr = Object.keys(searchStartSectionNames).map(
	(key) => searchStartSectionNames[key],
);
/* eslint-enable import/namespace */

export const ageRangeValue = PropTypes.shape({
	after: PropTypes.number,
	before: PropTypes.number,
});

export const atLeastValue = PropTypes.number;

export const singleAutocompleteValue = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

export const singleAutocompleteEditValue = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	value: singleAutocompleteValue,
});

export const autocompleteValue = PropTypes.arrayOf(singleAutocompleteValue.isRequired);

export const dateRangeValue = PropTypes.shape({
	after: PropTypes.string,
	before: PropTypes.string,
});

export const listValue = PropTypes.arrayOf(PropTypes.number.isRequired);

export const documentFilterValue = PropTypes.shape({
	cause: listValue.isRequired,
	action: listValue.isRequired,
	result: listValue.isRequired,
	issue: PropTypes.arrayOf(listValue.isRequired).isRequired,
});

export const dfgValue = PropTypes.arrayOf(documentFilterValue.isRequired);

export const singlePfaValue = PropTypes.shape({
	affiliates: PropTypes.bool,
	match: PropTypes.oneOf(["is", "begins", "starts"]).isRequired,
	name: PropTypes.string.isRequired,
});

export const pfaValue = PropTypes.arrayOf(singlePfaValue.isRequired);

export const termDefDescValue = PropTypes.shape({
	match: PropTypes.oneOf(["is", "contains", "resembles"]).isRequired,
	strings: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

export const textValue = PropTypes.shape({
	match: PropTypes.oneOf(["natural", "boolean"]).isRequired,
	query: PropTypes.string.isRequired,
});

export const crpValue = PropTypes.shape({
	reg_nos: autocompleteValue.isRequired,
	strings: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

export const tmpValue = PropTypes.shape({
	reg_nos: autocompleteValue.isRequired,
	ser_nos: autocompleteValue.isRequired,
	strings: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

export const radioValue = PropTypes.oneOfType([
	PropTypes.number.isRequired,
	PropTypes.string.isRequired,
]);

export const treeValue = PropTypes.arrayOf(PropTypes.number.isRequired);

const criterionValue = PropTypes.oneOfType([
	ageRangeValue,
	autocompleteValue,
	dateRangeValue,
	listValue,
	dfgValue,
	pfaValue,
	termDefDescValue,
	textValue,
	treeValue,
	radioValue,
]);

export const idsTitle = PropTypes.shape({
	ids: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	title: PropTypes.string.isRequired,
});

export const apiCriterion = PropTypes.shape({
	messages: PropTypes.arrayOf(PropTypes.string.isRequired),
	highlight: PropTypes.arrayOf(PropTypes.number.isRequired),
	joinpath_name: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: criterionValue,
});

export const apiCriterionEditor = PropTypes.shape({
	supports_and: PropTypes.bool,
	supports_upload: PropTypes.bool,
	type: PropTypes.oneOf(inputTypesArr).isRequired,
});

const fieldProperties = {
	default: PropTypes.bool.isRequired,
	extended: PropTypes.bool,
	name: PropTypes.string.isRequired,
	renderer: PropTypes.oneOf(rendererNamesArr).isRequired,
	resizeable: PropTypes.bool.isRequired,
	sort: PropTypes.number,
	width: PropTypes.number,
};

export const apiSubfield = PropTypes.shape({
	...fieldProperties,
	title: PropTypes.string,
});

export const apiField = PropTypes.shape({
	...fieldProperties,
	title: PropTypes.string.isRequired,
	subfield: PropTypes.arrayOf(apiSubfield),
});

export const apiSearch = PropTypes.shape({
	criteria: PropTypes.arrayOf(apiCriterion.isRequired).isRequired,
	field_names: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	section_names: PropTypes.arrayOf(PropTypes.string.isRequired),
	target_name: PropTypes.string.isRequired,
});

export const apiBinderTab = PropTypes.shape({
	client_id: PropTypes.number,
	content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	dirty: PropTypes.bool,
	editable: PropTypes.bool.isRequired,
	link_id: PropTypes.string,
	search: apiSearch,
	title: PropTypes.string.isRequired,
});

export const binderAlertRate = PropTypes.oneOf(binderAlertRatesArr);

export const apiBinderObserver = PropTypes.shape({
	alert_history: PropTypes.bool.isRequired,
	alert_rate: binderAlertRate.isRequired,
	email: PropTypes.string.isRequired,
	first_name: PropTypes.string.isRequired,
	full_name: PropTypes.string.isRequired,
	last_name: PropTypes.string.isRequired,
	user_id: PropTypes.number.isRequired,
});

export const reduxBinderObserver = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	alertHistory: PropTypes.bool.isRequired,
	alertRate: binderAlertRate.isRequired,
	email: PropTypes.string.isRequired,
	userId: PropTypes.number.isRequired,
	firstName: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired,
});

export const alertUser = PropTypes.shape({
	alertHistory: PropTypes.bool,
	alertRate: binderAlertRate,
	email: PropTypes.string.isRequired,
	firstName: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired,
	observerId: PropTypes.string,
	selected: PropTypes.bool.isRequired,
	userId: PropTypes.number.isRequired,
});

const binderContent = PropTypes.oneOfType([
	PropTypes.shape({
		[binderContentKeys.FILTERS_DRAWER_KEY]: PropTypes.bool,
		[binderContentKeys.TAB_ORDER_KEY]: PropTypes.arrayOf(PropTypes.number),
	}),
	PropTypes.array,
]);

export const libraryName = PropTypes.oneOf(libraryNamesArr);

export const binderType = PropTypes.oneOf(binderTypesArr);

const binderLink = PropTypes.shape({
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
});

export const apiBinder = PropTypes.shape({
	alert_history: PropTypes.bool.isRequired,
	alert_rate: binderAlertRate.isRequired,
	bookmarked: PropTypes.bool.isRequired,
	clientcode: PropTypes.string,
	content: binderContent,
	create_time: PropTypes.instanceOf(Date),
	description: PropTypes.string,
	editable: PropTypes.bool.isRequired,
	id: PropTypes.number.isRequired,
	library_name: libraryName.isRequired,
	links: PropTypes.arrayOf(binderLink.isRequired),
	observers: PropTypes.arrayOf(apiBinderObserver.isRequired).isRequired,
	owner_name: PropTypes.string,
	owner_user_id: PropTypes.number,
	shareable: PropTypes.bool.isRequired,
	tab_count: PropTypes.number,
	tabs: PropTypes.arrayOf(apiBinderTab.isRequired).isRequired,
	title: PropTypes.string.isRequired,
	type: binderType.isRequired,
	update_time: PropTypes.instanceOf(Date),
	view_time: PropTypes.instanceOf(Date),
});

export const apiSubsearch = PropTypes.shape({
	criterion_name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	value: PropTypes.shape({
		search: apiSearch.isRequired,
		title: PropTypes.string.isRequired,
	}),
});

export const binderOrderItemId = PropTypes.oneOfType([
	PropTypes.string.isRequired,
	PropTypes.number.isRequired,
]);

export const binderOrderItemType = PropTypes.oneOf(binderOrderItemTypesArr);

export const binderOrderItem = PropTypes.shape({
	id: binderOrderItemId.isRequired,
	label: PropTypes.string.isRequired,
	type: binderOrderItemType.isRequired,
	icon: PropTypes.string,
});

binderOrderItem.children = PropTypes.arrayOf(binderOrderItem).isRequired;

const binderFields = {
	alertHistory: PropTypes.bool.isRequired,
	alertRate: binderAlertRate.isRequired,
	bookmarked: PropTypes.bool.isRequired,
	clientcode: PropTypes.string,
	content: binderContent,
	createTime: PropTypes.instanceOf(Date),
	description: PropTypes.string,
	dirty: PropTypes.bool.isRequired,
	editable: PropTypes.bool.isRequired,
	id: PropTypes.number.isRequired,
	libraryName: libraryName.isRequired,
	links: PropTypes.arrayOf(binderLink.isRequired),
	observers: PropTypes.arrayOf(apiBinderObserver.isRequired).isRequired,
	orderItems: PropTypes.arrayOf(binderOrderItem).isRequired,
	ownerName: PropTypes.string,
	ownerUserId: PropTypes.number,
	shareable: PropTypes.bool.isRequired,
	tabCount: PropTypes.number,
	title: PropTypes.string.isRequired,
	type: binderType.isRequired,
	updateTime: PropTypes.instanceOf(Date),
	viewTime: PropTypes.instanceOf(Date),
};

export const reduxBinder = PropTypes.shape({
	...binderFields,
	tabIds: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export const reduxBinderWithoutTabs = PropTypes.shape({
	...binderFields,
});

export const libraryService = PropTypes.oneOf(libraryServicesArr);

export const libraryServices = PropTypes.arrayOf(libraryService.isRequired);

export const reduxField = PropTypes.shape({
	default: PropTypes.bool.isRequired,
	extended: PropTypes.bool,
	featureRequired: libraryService,
	name: PropTypes.string.isRequired,
	renderer: PropTypes.oneOf(rendererNamesArr).isRequired,
	resizeable: PropTypes.bool.isRequired,
	sort: PropTypes.number,
	title: PropTypes.string.isRequired,
	width: PropTypes.number,
});

export const binderTabContent = PropTypes.oneOfType([
	PropTypes.shape({
		[tabContentKeys.AVERAGE_KEY]: PropTypes.bool,
		[tabContentKeys.CHART_PERCENT_KEY]: PropTypes.bool,
		[tabContentKeys.CHART_STYLE_KEY]: PropTypes.string,
		[tabContentKeys.COLUMN_ORDER_KEY]: PropTypes.arrayOf(reduxField.isRequired),
		[tabContentKeys.COLUMN_WIDTH_KEY]: PropTypes.array,
		[tabContentKeys.COUNT_KEY]: PropTypes.bool,
		[tabContentKeys.ESTIMATED_KEY]: PropTypes.bool,
		[tabContentKeys.IN_PROGRESS_SEARCH]: PropTypes.bool,
		[tabContentKeys.MAX_KEY]: PropTypes.bool,
		[tabContentKeys.MIN_KEY]: PropTypes.bool,
		[tabContentKeys.NUMBERS_KEY]: PropTypes.bool,
		[tabContentKeys.Q0_KEY]: PropTypes.bool,
		[tabContentKeys.Q1_KEY]: PropTypes.bool,
		[tabContentKeys.Q2_KEY]: PropTypes.bool,
		[tabContentKeys.Q3_KEY]: PropTypes.bool,
		[tabContentKeys.Q4_KEY]: PropTypes.bool,
		[tabContentKeys.REQUIRED_CRITERION]: PropTypes.shape({
			criterion: PropTypes.any,
			joinpath_name: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
		}),
		[tabContentKeys.SORT_ORDER_KEY]: PropTypes.arrayOf(PropTypes.string.isRequired),
		[tabContentKeys.TABLE_PERCENT_KEY]: PropTypes.bool,
	}),
	PropTypes.array,
]);

export const idName = PropTypes.shape({
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
});

export const reduxBinderTab = PropTypes.shape({
	binderId: PropTypes.number,
	clientId: PropTypes.number,
	content: binderTabContent,
	dataWarningShown: PropTypes.bool,
	dirty: PropTypes.bool,
	editable: PropTypes.bool,
	editCriterionName: PropTypes.string,
	editJoinpathName: PropTypes.string,
	featureRequired: libraryService,
	id: PropTypes.number,
	linkId: PropTypes.string,
	search: apiSearch,
	sectionIdNames: PropTypes.arrayOf(idName.isRequired),
	title: PropTypes.string,
});

export const binderNavTab = PropTypes.shape({
	analytics: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	id: PropTypes.number.isRequired,
});

export const apiJoinpath = PropTypes.shape({
	criterion_name: PropTypes.string.isRequired,
	description: PropTypes.string,
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
});

export const searchResultsType = PropTypes.oneOf(searchResultsTypeArr);
export const targetDisplay = PropTypes.oneOf(targetDisplayValsArr);

const apiTargetTab = PropTypes.shape({
	title: PropTypes.string.isRequired,
	icon_name: PropTypes.string,
	criteria: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

export const apiTarget = PropTypes.shape({
	analytics: PropTypes.bool.isRequired,
	description: PropTypes.string,
	display: targetDisplay.isRequired,
	example_url: PropTypes.string,
	fields: PropTypes.arrayOf(apiField.isRequired).isRequired,
	joinpaths: PropTypes.arrayOf(apiJoinpath.isRequired).isRequired,
	library_name: PropTypes.string.isRequired,
	long_description: PropTypes.string,
	name: PropTypes.string.isRequired,
	tabs: PropTypes.arrayOf(apiTargetTab.isRequired).isRequired,
	title: PropTypes.string.isRequired,
	type: searchResultsType.isRequired,
	warning: PropTypes.string,
	xls: PropTypes.bool.isRequired,
});

export const apiExpressReport = PropTypes.shape({
	criteria: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	description: PropTypes.string.isRequired,
	joinpaths: PropTypes.arrayOf(apiJoinpath.isRequired).isRequired,
	library_name: libraryName.isRequired,
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
});

export const reduxSearch = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	apiObject: apiSearch,
	fieldIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	tabIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	targetName: PropTypes.string.isRequired,
});

export const reduxReportSearch = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	comparison: PropTypes.bool.isRequired,
	description: PropTypes.string.isRequired,
	exampleUrl: PropTypes.string,
	joinpathIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	libraryName: libraryName.isRequired,
	longDescription: PropTypes.string,
	name: PropTypes.string.isRequired,
	tabIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	title: PropTypes.string.isRequired,
});

export const reduxTargetOrReportSearch = PropTypes.oneOfType([
	reduxSearch.isRequired,
	reduxReportSearch.isRequired,
]);

export const reduxJoinpath = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	criterion_name: PropTypes.string.isRequired,
	description: PropTypes.string,
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
});

export const reduxCriterion = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	allJoinpathIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	hasValidationError: PropTypes.bool.isRequired,
	highlight: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	messages: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	multiples: PropTypes.number,
	name: PropTypes.string.isRequired,
	selectedJoinpathId: PropTypes.string.isRequired,
	supportsAnd: PropTypes.bool.isRequired,
	supportsUpload: PropTypes.bool.isRequired,
	type: PropTypes.oneOf(inputTypesArr).isRequired,
	validating: PropTypes.bool.isRequired,
	value: criterionValue,
});

export const reduxTarget = PropTypes.shape({
	analytics: PropTypes.bool.isRequired,
	description: PropTypes.string,
	dashboards: PropTypes.arrayOf(PropTypes.string.isRequired),
	display: targetDisplay.isRequired,
	example_url: PropTypes.string,
	fieldIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	forms: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			icon: PropTypes.string,
			criteriaNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
		}).isRequired,
	).isRequired,
	joinpathIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	library_name: libraryName,
	long_description: PropTypes.string,
	name: PropTypes.string,
	title: PropTypes.string,
	type: searchResultsType.isRequired,
	warning: PropTypes.string,
	xls: PropTypes.bool.isRequired,
});

const criterionIdList = PropTypes.arrayOf(PropTypes.string.isRequired);

export const reduxSearchTab = PropTypes.shape({
	__id: PropTypes.string.isRequired,
	criterionIdsDesktop: PropTypes.arrayOf(criterionIdList.isRequired).isRequired,
	criterionIdsFullWidth: criterionIdList.isRequired,
	criterionIdsTablet: PropTypes.arrayOf(criterionIdList.isRequired).isRequired,
	editorHeights: PropTypes.object.isRequired,
	icon: PropTypes.string,
	title: PropTypes.string.isRequired,
});

export const profile = PropTypes.shape({
	multiSelect: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
});

const libraryPrice = PropTypes.shape({
	monthly_rate: PropTypes.number.isRequired,
	per_user_rate: PropTypes.number,
	title: PropTypes.string.isRequired,
});

export const library = PropTypes.shape({
	all_services: PropTypes.bool.isRequired,
	description: PropTypes.string.isRequired,
	name: libraryName.isRequired,
	pricing: PropTypes.arrayOf(libraryPrice.isRequired).isRequired,
	profiles: PropTypes.arrayOf(profile.isRequired).isRequired,
	services: libraryServices.isRequired,
	title: PropTypes.string.isRequired,
});

export const reduxLibrary = PropTypes.shape({
	allServices: PropTypes.bool.isRequired,
	description: PropTypes.string.isRequired,
	disabled: PropTypes.bool.isRequired,
	name: libraryName.isRequired,
	pricing: PropTypes.arrayOf(libraryPrice.isRequired).isRequired,
	profiles: PropTypes.arrayOf(profile.isRequired).isRequired,
	services: libraryServices.isRequired,
	targetsLoaded: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
});

const usage = PropTypes.shape({
	analytics_tabs_alerted: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	analytics_tabs_bookmarked: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	analytics_tabs_shared: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	analytics_tabs_viewed: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	basic_tabs_alerted: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	basic_tabs_bookmarked: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	basic_tabs_shared: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	basic_tabs_viewed: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
	publications_clicked: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	publications_delivered: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	publications_opened: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
});

export const practiceArea = PropTypes.shape({
	active: PropTypes.bool.isRequired,
	docket_report: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	new_cases: PropTypes.bool.isRequired,
	usage: usage.isRequired,
});

export const groupLibrary = PropTypes.shape({
	[libraryServiceValues.ANALYTICS]: PropTypes.bool.isRequired,
	current_level: PropTypes.string.isRequired,
	current_users: PropTypes.number.isRequired,
	max_users: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
});

export const reduxGroupLibrary = PropTypes.shape({
	[libraryServiceValues.ANALYTICS]: PropTypes.bool.isRequired,
	currentLevel: PropTypes.string.isRequired,
	currentUsers: PropTypes.number.isRequired,
	maxUsers: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
});

export const toast = PropTypes.shape({
	displayTime: PropTypes.number.isRequired,
	iconName: PropTypes.string,
	id: PropTypes.string.isRequired,
	manualDismiss: PropTypes.bool.isRequired,
	message: PropTypes.string.isRequired,
	visible: PropTypes.bool.isRequired,
});

export const legendEntry = PropTypes.shape({
	color: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired])
		.isRequired,
	value: PropTypes.number,
	valueString: PropTypes.string,
});

export const tableValue = PropTypes.shape({
	criteria: PropTypes.arrayOf(apiCriterion),
	label: PropTypes.string,
	percent: PropTypes.number,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
});

const baseTableColumnProperties = {
	name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	estimate: PropTypes.bool,
	title: PropTypes.string.isRequired,
};

export const tableColumn = PropTypes.shape(baseTableColumnProperties);

export const tableColumnOptionalTitle = PropTypes.shape({
	...baseTableColumnProperties,
	title: PropTypes.string,
});

export const tableSeries = PropTypes.shape({
	name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	title: PropTypes.string.isRequired,
	color: PropTypes.string,
	data: PropTypes.arrayOf(tableValue.isRequired).isRequired,
	total: PropTypes.bool.isRequired,
});

export const numberTileData = PropTypes.oneOfType([
	PropTypes.number.isRequired,
	PropTypes.string.isRequired,
]);

export const remediesTileData = PropTypes.arrayOf(
	PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
);

export const sankeyPath = PropTypes.arrayOf(
	PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
);

const sankeyTitle = PropTypes.string;

export const sankeyTileData = PropTypes.shape({
	paths: PropTypes.arrayOf(sankeyPath.isRequired).isRequired,
	titles: PropTypes.arrayOf(sankeyTitle.isRequired).isRequired,
});

export const milestoneConfig = PropTypes.shape({
	insideLabel: PropTypes.bool,
});

export const barTileConfig = PropTypes.shape({
	chartHeight: PropTypes.number,
	hideZeros: PropTypes.bool,
	horizontalLabelsAbove: PropTypes.bool,
	insideLabel: PropTypes.bool,
	legendHeight: PropTypes.number,
	line: PropTypes.bool,
	showPercentages: PropTypes.bool,
	showXAxisLabels: PropTypes.bool,
	topN: PropTypes.number,
});

export const sankeyTileConfig = PropTypes.shape({
	hideTitleFilters: PropTypes.arrayOf(PropTypes.string),
	topN: PropTypes.number,
});

export const barTileData = PropTypes.shape({
	columns: PropTypes.arrayOf(tableColumn.isRequired).isRequired,
	series: PropTypes.arrayOf(tableSeries.isRequired).isRequired,
});

export const horizontalBarTileData = PropTypes.shape({
	columns: PropTypes.arrayOf(tableColumnOptionalTitle.isRequired).isRequired,
	series: PropTypes.arrayOf(tableSeries.isRequired).isRequired,
});

export const pieSlice = PropTypes.shape({
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	color: PropTypes.string,
	count: PropTypes.number.isRequired,
});

pieSlice.children = PropTypes.arrayOf(pieSlice.isRequired);

export const clientPieSlice = PropTypes.shape({
	color: PropTypes.string,
	count: PropTypes.number.isRequired,
	endAngle: PropTypes.number.isRequired,
	id: PropTypes.string.isRequired,
	other: PropTypes.arrayOf(legendEntry).isRequired,
	parents: PropTypes.arrayOf(legendEntry).isRequired,
	percent: PropTypes.number.isRequired,
	siblings: PropTypes.arrayOf(legendEntry).isRequired,
	startAngle: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
});

clientPieSlice.children = PropTypes.arrayOf(clientPieSlice.isRequired);

export const pieTileData = PropTypes.arrayOf(pieSlice);

export const pieTileConfig = PropTypes.shape({
	hiddenCategories: PropTypes.arrayOf(PropTypes.string.isRequired),
});

export const statsTileLine = PropTypes.shape({
	title: PropTypes.string,
	search: apiSearch,
	value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
});

export const statsTileData = PropTypes.arrayOf(
	PropTypes.shape({
		title: PropTypes.string,
		lines: PropTypes.arrayOf(statsTileLine).isRequired,
	}),
);

// colors[0] used for 1st-3rd quartile box, outlier dots, and legend color
// colors[1] used for 2nd-98th percentile box
// colors[2] used for average and median markers
const milestoneColors = PropTypes.arrayOf(PropTypes.string.isRequired);

export const milestoneData = PropTypes.shape({
	average: PropTypes.number,
	colors: milestoneColors,
	count: PropTypes.number.isRequired, // number of data points that were used to make data
	display_order: PropTypes.number,
	footnote_name: PropTypes.string,
	heading: PropTypes.string,
	link: PropTypes.string,
	max: PropTypes.number,
	min: PropTypes.number,
	outliers: PropTypes.arrayOf(PropTypes.number).isRequired, // actual points if less than 10
	q0: PropTypes.number, // 2nd percentile
	q1: PropTypes.number, // 1st quartile
	q2: PropTypes.number, // median
	q3: PropTypes.number, // third quartile
	q4: PropTypes.number, // 98th percentile
	row_name: PropTypes.number.isRequired,
	search: apiSearch,
	title: PropTypes.string.isRequired, // title to be used for label
});

export const milestonesTileData = PropTypes.arrayOf(milestoneData);

export const timelineEvent = PropTypes.shape({
	name: PropTypes.string.isRequired,
	epoch: PropTypes.string.isRequired,
	colors: PropTypes.arrayOf(PropTypes.string.isRequired),
});

export const timelineDataset = PropTypes.shape({
	case_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	case_name: PropTypes.string.isRequired,
	case_number: PropTypes.string.isRequired,
	events: PropTypes.arrayOf(timelineEvent).isRequired,
	show_by_default: PropTypes.bool,
});

export const timelinesTileData = PropTypes.arrayOf(timelineDataset);

export const resultsGridTileData = PropTypes.shape({
	search: apiSearch.isRequired,
	total: PropTypes.number.isRequired,
});

export const htmlTileData = PropTypes.string;

const tileRadioButton = PropTypes.shape({
	criteria: PropTypes.arrayOf(apiCriterion).isRequired,
	selected: PropTypes.bool,
	title: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["RadioButton"]).isRequired,
});

export const tileRadioGroup = PropTypes.shape({
	base_search: apiSearch.isRequired,
	radio_buttons: PropTypes.arrayOf(tileRadioButton.isRequired).isRequired,
	title: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["RadioButtonGroup"]).isRequired,
});

export const tile = PropTypes.shape({
	config: PropTypes.oneOfType([barTileConfig, sankeyTileConfig, pieTileConfig, milestoneConfig]),
	content: PropTypes.any,
	controls: PropTypes.arrayOf(tileRadioGroup.isRequired),
	data: PropTypes.oneOfType([
		barTileData.isRequired,
		horizontalBarTileData.isRequired,
		htmlTileData.isRequired,
		milestonesTileData.isRequired,
		numberTileData.isRequired,
		pieTileData.isRequired,
		remediesTileData.isRequired,
		sankeyTileData.isRequired,
		statsTileData.isRequired,
		timelinesTileData.isRequired,
		resultsGridTileData.isRequired,
	]).isRequired,
	description: PropTypes.string,
	detail: PropTypes.string,
	name: PropTypes.oneOf(tileNamesArr).isRequired,
	showdetailtext: PropTypes.string,
	title: PropTypes.string,
	id: PropTypes.string.isRequired,
});

export const stackedBar = PropTypes.shape({
	color: PropTypes.string.isRequired,
	labelString: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	value: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired,
});

const binderWallColumnsContent = PropTypes.oneOfType([
	PropTypes.objectOf(PropTypes.bool.isRequired),
	PropTypes.array,
]);

export const userContent = PropTypes.shape({
	[userContentKeys.BINDER_WALL_COLUMNS]: binderWallColumnsContent,
	[userContentKeys.DISABLE_CHANGE_BINDER_WARNING]: PropTypes.bool,
	[userContentKeys.DEFAULT_TARGET_FIELDS]: PropTypes.objectOf(
		PropTypes.arrayOf(PropTypes.string.isRequired),
	),
	[userContentKeys.DEFAULT_TARGET_COLUMN_ORDER]: PropTypes.objectOf(
		PropTypes.arrayOf(PropTypes.string.isRequired),
	),
	[userContentKeys.DEFAULT_TARGET_COLUMN_WIDTHS]: PropTypes.objectOf(
		PropTypes.arrayOf(PropTypes.number.isRequired),
	),
});

export const user = PropTypes.shape({
	beta: PropTypes.bool.isRequired,
	content: userContent,
	email: PropTypes.string.isRequired,
	first_name: PropTypes.string.isRequired,
	group_admin: PropTypes.bool.isRequired,
	group_id: PropTypes.number,
	id: PropTypes.number.isRequired,
	individual: PropTypes.bool,
	last_login: PropTypes.instanceOf(Date),
	last_name: PropTypes.string.isRequired,
	password_reset: PropTypes.instanceOf(Date),
	phone_number: PropTypes.string,
	practice_areas: PropTypes.arrayOf(practiceArea.isRequired).isRequired,
	super_admin: PropTypes.bool.isRequired,
	job_role: PropTypes.string,
});

export const reduxUser = PropTypes.shape({
	beta: PropTypes.bool.isRequired,
	content: userContent,
	email: PropTypes.string.isRequired,
	firstName: PropTypes.string.isRequired,
	groupAdmin: PropTypes.bool.isRequired,
	groupId: PropTypes.number,
	id: PropTypes.number.isRequired,
	individual: PropTypes.bool,
	lastLogin: PropTypes.instanceOf(Date),
	lastName: PropTypes.string.isRequired,
	passwordReset: PropTypes.instanceOf(Date),
	phoneNumber: PropTypes.string,
	practiceAreas: PropTypes.arrayOf(practiceArea.isRequired).isRequired,
	startTime: PropTypes.instanceOf(Date),
	superAdmin: PropTypes.bool.isRequired,
	job_role: PropTypes.string,
});

export const tooltipContents = PropTypes.shape({
	entries: PropTypes.arrayOf(legendEntry.isRequired),
	text: PropTypes.string,
	title: PropTypes.string,
});

export const sankeyNode = PropTypes.shape({
	depth: PropTypes.number,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
});

export const sankeyLink = PropTypes.shape({
	source: PropTypes.string.isRequired,
	target: PropTypes.string.isRequired,
	value: PropTypes.number.isRequired,
});

export const binderChangelog = PropTypes.arrayOf(
	PropTypes.shape({
		author: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		event_time: PropTypes.instanceOf(Date).isRequired,
	}),
);

export const relatedSearch = PropTypes.shape({
	id: PropTypes.string.isRequired,
	isAnalytics: PropTypes.bool.isRequired,
	search: apiSearch.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
});

export const titleUrlRenderer = PropTypes.shape({
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
});

export const binderWallFilter = PropTypes.shape({
	text: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
});

export const binderWallSort = PropTypes.shape({
	text: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	direction: PropTypes.oneOf(["ASC", "DESC"]).isRequired,
});

export const stepperStep = PropTypes.shape({
	label: PropTypes.string.isRequired,
	completed: PropTypes.bool.isRequired,
});

export const accountNavigationButton = PropTypes.shape({
	label: PropTypes.string.isRequired,
	iconName: PropTypes.string.isRequired,
	to: PropTypes.oneOfType([
		PropTypes.string.isRequired,
		PropTypes.arrayOf(
			PropTypes.shape({
				label: PropTypes.string.isRequired,
				to: PropTypes.string.isRequired,
			}),
		).isRequired,
	]).isRequired,
	style: PropTypes.object.isRequired,
});

export const searchPageParams = PropTypes.shape({
	libraryName: libraryName.isRequired,
	reportName: PropTypes.string,
	targetName: PropTypes.string,
});

export const chartLegendEntry = PropTypes.shape({
	color: PropTypes.oneOfType([
		PropTypes.string.isRequired,
		PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	]).isRequired,
	display_order: PropTypes.number,
	displayTitle: PropTypes.string,
	preventStrikeThrough: PropTypes.bool,
	strikeThrough: PropTypes.bool,
	title: PropTypes.string.isRequired,
});

export const timelineChartTooltip = PropTypes.shape({
	caseId: PropTypes.number.isRequired,
	eventId: PropTypes.string.isRequired,
	pos: PropTypes.shape({
		x: PropTypes.number.isRequired,
		y: PropTypes.number.isRequired,
	}),
});

const tileContentProperties = {
	[tileContentKeys.CONTROLS]: PropTypes.arrayOf(tileRadioGroup.isRequired),
};

// NOTE(CK): This shouldn't actually be an array, but when we save an empty object, PHP encodes that
// as an empty array: https://stackoverflow.com/questions/48334345/what-is-the-difference-between-
// json-encoderesponse-json-force-object-and-jso So, the API will sometimes return an empty array.
export const contentObject = PropTypes.oneOfType([
	PropTypes.object.isRequired,
	PropTypes.array.isRequired,
]);

export const timelineChartContent = PropTypes.shape({
	...tileContentProperties,
	[tileContentKeys.HIDDEN_CATEGORIES]: contentObject.isRequired,
	chartType: PropTypes.string.isRequired,
	visibleDatasets: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired])
		.isRequired,
	tooltips: PropTypes.shape({
		[timelineChartTypes.CALENDAR_DAYS]: PropTypes.arrayOf(timelineChartTooltip).isRequired,
		[timelineChartTypes.DAYS_FROM_FILING]: PropTypes.arrayOf(timelineChartTooltip).isRequired,
	}),
});

export const pieChartContent = PropTypes.shape({
	...tileContentProperties,
	[tileContentKeys.HIDDEN_CATEGORIES]: contentObject.isRequired,
});

export const horizontalBarChartContent = PropTypes.shape({
	...tileContentProperties,
	[tileContentKeys.HIDDEN_SERIES]: contentObject.isRequired,
});

// NOTE(CK): This shouldn't actually be an array, see contentObject comment
export const stackedBarChartContent = PropTypes.oneOfType([
	PropTypes.shape({
		...tileContentProperties,
		showPercentages: PropTypes.bool,
		showPercentagesToggle: PropTypes.bool,
	}),
	PropTypes.array,
]);

const sankeyIncludedNode = PropTypes.shape({
	[tileContentKeys.COLUMN_TITLE]: PropTypes.string.isRequired,
	[tileContentKeys.PATH_VALUE]: PropTypes.string.isRequired,
});

export const sankeyChartContent = PropTypes.oneOfType([
	PropTypes.array,
	PropTypes.shape({
		...tileContentProperties,
		[tileContentKeys.INCLUDE_NODES]: PropTypes.arrayOf(sankeyIncludedNode),
	}),
]);

export const tableContent = PropTypes.shape({
	...tileContentProperties,
});

export const milestoneChartContent = PropTypes.shape({
	...tileContentProperties,
});

export const binderTabViewMenu = PropTypes.oneOf(binderTabViewMenuNamesArr);

export const paymethod = PropTypes.shape({
	name: PropTypes.string.isRequired,
	number: PropTypes.string.isRequired,
});

export const searchFilterMemo = PropTypes.object;

export const searchResultsFilter = PropTypes.shape({
	add_criteria: PropTypes.arrayOf(apiCriterion.isRequired),
	remove_criterion_name: PropTypes.arrayOf(PropTypes.string),
	count: PropTypes.number,
	id: PropTypes.string.isRequired,
	memo: searchFilterMemo,
	selected: PropTypes.bool,
	title: PropTypes.string.isRequired,
});

searchResultsFilter.children = PropTypes.arrayOf(searchResultsFilter);

export const libraryPageParams = PropTypes.shape({
	libraryName: libraryName.isRequired,
});

export const tileLegend = PropTypes.arrayOf(chartLegendEntry);

export const binderTabFilter = PropTypes.shape({
	title: PropTypes.string.isRequired,
	paths: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

const aStyle = PropTypes.oneOfType([PropTypes.object, PropTypes.bool]);

export const aphroditeStyles = PropTypes.oneOfType([aStyle, PropTypes.arrayOf(aStyle)]);

export const menuItem = PropTypes.shape({
	aStyles: aphroditeStyles,
	disabled: PropTypes.bool,
	id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]).isRequired,
	label: PropTypes.string.isRequired,
});

export const binderTabDrawer = PropTypes.oneOf(tabDrawerTypesArr);

export const group = PropTypes.shape({
	libraries: PropTypes.arrayOf(reduxGroupLibrary.isRequired),
	managerEmails: PropTypes.arrayOf(PropTypes.string),
	userIds: PropTypes.arrayOf(PropTypes.number),
});

export const tileToggle = PropTypes.shape({
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	visible: PropTypes.bool.isRequired,
});

export const resultsGridSort = PropTypes.arrayOf(PropTypes.string.isRequired);

export const patentNumberIdData = PropTypes.shape({
	patent_number: PropTypes.string.isRequired,
	patent_id: PropTypes.number.isRequired,
});

export const partyNameIdData = PropTypes.shape({
	party_name: PropTypes.string.isRequired,
	party_id: PropTypes.number.isRequired,
});

export const judgeNameIdData = PropTypes.shape({
	judge_name: PropTypes.string,
	judge_id: PropTypes.number,
});

export const firmNameIdData = PropTypes.shape({
	firm_name: PropTypes.string.isRequired,
	firm_id: PropTypes.number.isRequired,
});

export const attorneyNameIdData = PropTypes.shape({
	attorney_name: PropTypes.string.isRequired,
	attorney_id: PropTypes.number.isRequired,
});

export const expertNameIdData = PropTypes.shape({
	expert_name: PropTypes.string.isRequired,
	expert_id: PropTypes.number.isRequired,
});

export const attorneyNameIdArrayData = PropTypes.arrayOf(attorneyNameIdData).isRequired;

export const caseNumberIdData = PropTypes.shape({
	case_number: PropTypes.string.isRequired,
	case_id: PropTypes.number.isRequired,
});

export const caseNameIdData = PropTypes.shape({
	case_name: PropTypes.string.isRequired,
	case_id: PropTypes.number.isRequired,
});

export const caseCiteData = PropTypes.shape({
	case_name: PropTypes.string.isRequired,
	case_number: PropTypes.string.isRequired,
	case_id: PropTypes.number.isRequired,
	court_abbreviation: PropTypes.string.isRequired,
	court_id: PropTypes.number.isRequired,
});

export const caseLinkData = PropTypes.shape({
	case_link_label: PropTypes.string.isRequired,
	text: PropTypes.string,
	case_id: PropTypes.number.isRequired,
});

export const documentLinkData = PropTypes.shape({
	document_link_label: PropTypes.string.isRequired,
	text: PropTypes.string,
	document_id: PropTypes.number.isRequired,
});

export const actionNameDocIdData = PropTypes.shape({
	action_name: PropTypes.string.isRequired,
	document_id: PropTypes.number.isRequired,
});

export const patentNameIdData = PropTypes.shape({
	patent_name: PropTypes.string.isRequired,
	patent_id: PropTypes.number.isRequired,
});

export const courtAbbrevIdData = PropTypes.shape({
	court_abbreviation: PropTypes.string.isRequired,
	court_id: PropTypes.number.isRequired,
});

export const annotationsData = PropTypes.shape({
	annotation_id: PropTypes.number,
	annotation_text: PropTypes.string,
	action_name: PropTypes.string,
	cause_name: PropTypes.string,
	result_name: PropTypes.string,
	issues: PropTypes.arrayOf(
		PropTypes.shape({
			grandparent: PropTypes.string,
			name: PropTypes.string.isRequired,
			parent: PropTypes.string.isRequired,
		}),
	),
	page_number: PropTypes.number,
});

export const treeNode = PropTypes.shape({
	count: PropTypes.number,
	depth: PropTypes.number.isRequired,
	expanded: PropTypes.bool.isRequired,
	hasWarning: PropTypes.bool.isRequired,
	highlighted: PropTypes.bool.isRequired,
	htmlContent: PropTypes.string,
	id: PropTypes.number.isRequired,
	indices: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
	title: PropTypes.string.isRequired,
});
treeNode.children = PropTypes.arrayOf(treeNode.isRequired).isRequired;

export const profileType = PropTypes.oneOf([
	binderTypes.ATTORNEY,
	binderTypes.CASE,
	binderTypes.EXPERT,
	binderTypes.FIRM,
	binderTypes.JUDGE,
	binderTypes.PARTY,
	binderTypes.PATENT,
	binderTypes.COURT,
	binderTypes.COPYRIGHT,
	binderTypes.TRADEMARK,
]);

export const dateListOption = PropTypes.shape({
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: dateRangeValue.isRequired,
});

export const binderListFilter = PropTypes.oneOf(binderListFiltersArr);

export const binderPageParams = PropTypes.shape({
	libraryName: libraryName.isRequired,
	binderId: PropTypes.string.isRequired,
	binderType: binderType.isRequired,
});

export const reduxTileSection = PropTypes.shape({
	desktop: PropTypes.any.isRequired,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	phone: PropTypes.any.isRequired,
	tablet: PropTypes.any.isRequired,
	tileIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
});

export const litigationHistoryFirm = PropTypes.shape({
	firm_name: PropTypes.string,
	start_date: PropTypes.instanceOf(Date),
	end_date: PropTypes.instanceOf(Date),
});

export const litigationCaseParty = PropTypes.shape({
	end_date: PropTypes.instanceOf(Date),
	id: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	start_date: PropTypes.instanceOf(Date),
});

export const litigationHistoryCase = PropTypes.shape({
	filing_date: PropTypes.instanceOf(Date),
	id: PropTypes.number,
	name: PropTypes.string,
	number: PropTypes.string,
	parties: PropTypes.arrayOf(litigationCaseParty.isRequired).isRequired,
	termination_date: PropTypes.instanceOf(Date),
});

const routerLocationShape = {
	pathname: PropTypes.string.isRequired,
	query: PropTypes.string,
};

export const routerLocation = PropTypes.shape(routerLocationShape);
export const routerLocationWithQuery = (query) =>
	PropTypes.shape({ ...routerLocationShape, query });

export const routerParams = PropTypes.object;

export const route = PropTypes.shape({
	getComponent: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	onEnter: PropTypes.func.isRequired,
	path: PropTypes.string,
});

export const gridSelectedRow = PropTypes.shape({
	checked: PropTypes.bool.isRequired,
	url: PropTypes.string,
	isDownloadable: PropTypes.bool,
});

export const tabControlType = PropTypes.oneOf(tabControlTypesArr);

export const tabControlOption = PropTypes.shape({
	filter: PropTypes.arrayOf(searchResultsFilter.isRequired).isRequired,
	id: PropTypes.string.isRequired,
	selected: PropTypes.bool.isRequired,
});

export const tabControl = PropTypes.shape({
	options: PropTypes.arrayOf(tabControlOption.isRequired),
	memo: searchFilterMemo,
	title: PropTypes.string.isRequired,
	type: tabControlType.isRequired,
});

const formattedVal = PropTypes.shape({
	formattedValue: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
		.isRequired,
});

const rangeVal = PropTypes.shape({
	min: formattedVal,
	max: formattedVal,
	domainMin: formattedVal,
	domainMax: formattedVal,
});

const tableauVal = PropTypes.oneOfType([
	formattedVal.isRequired,
	rangeVal.isRequired,
	PropTypes.arrayOf(formattedVal.isRequired).isRequired,
]);

export const tableauFilter = PropTypes.shape({
	name: PropTypes.string.isRequired,
	type: PropTypes.oneOf(tableauFilterTypesArr).isRequired,
	value: tableauVal.isRequired,
	worksheetIndex: PropTypes.number.isRequired,
	worksheetName: PropTypes.string.isRequired,
});

export const tableauParameter = PropTypes.shape({
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	value: tableauVal.isRequired,
});

const matchShape = {
	isExact: PropTypes.bool.isRequired,
	params: PropTypes.object.isRequired,
	path: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
};

export const match = PropTypes.shape(matchShape);
export const matchWithParams = (params) =>
	PropTypes.shape({
		...matchShape,
		params,
	});

export const binderWallColumn = PropTypes.oneOf(binderWallColsArr);

export const searchStartSectionName = PropTypes.oneOf(searchStartSectionNamesArr);

export const relatedSearchTarget = PropTypes.shape({
	related: PropTypes.shape({
		editable: PropTypes.bool.isRequired,
		search: apiSearch.isRequired,
		title: PropTypes.string.isRequired,
	}).isRequired,
	target: reduxTarget.isRequired,
});

export const dropdownMenuOption = PropTypes.shape({
	checked: PropTypes.bool,
	count: PropTypes.number,
	disabled: PropTypes.bool,
	hasWarning: PropTypes.bool,
	label: PropTypes.string.isRequired,
	value: PropTypes.any.isRequired,
	featureRequired: libraryService,
});
